<template>
  <router-view></router-view>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "SIVO",
      meta: (function () {
        if (process.env.VUE_APP_IS_DEMO == 0) {
          return [
            { charset: "utf-8" },
            {
              "http-equiv": "X-UA-Compatible",
              content: "IE=edge,chrome=1",
            },
            {
              name: "viewport",
              content:
                "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0",
            },
          ];
        }
        return [
          { charset: "utf-8" },
          {
            "http-equiv": "X-UA-Compatible",
            content: "IE=edge,chrome=1",
          },
          {
            name: "viewport",
            content:
              "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0",
          },
          {
            itemprop: "name",
            content:
              "Sistema SIVO by Importare Software",
          },
          {
            itemprop: "description",
            content:
              "SIVO viaja con elegancia y comodidad",
          },
        ];
      })(),

      link: [
        { rel: "icon", type: "image/png", href: "/favicon.png" },
        {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700;800;900&display=swap",
        },
        {
          rel: "stylesheet",
          href: "https://use.fontawesome.com/releases/v5.6.3/css/all.css",
          integrity:
            "sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/",
          crossorigin: "anonymous",
        },
      ],

      script: (function () {
        if (process.env.VUE_APP_IS_DEMO == 1) {
          return [
            {
              hid: "gtm-script1",
              innerHTML: `
        (function (a, s, y, n, c, h, i, d, e) {
        s.className += " " + y;
        h.start = 1 * new Date();
        h.end = i = function() {
          s.className = s.className.replace(RegExp(" ?" + y), "");
        };
        (a[n] = a[n] || []).hide = h;
        setTimeout(function() {
          i();
          h.end = null;
        }, c);
        h.timeout = c;
      })(window, document.documentElement, "async-hide", "dataLayer", 4000, {
        "GTM-K9BGS8K": true
      });
        `,
              type: "text/javascript",
              charset: "utf-8",
            },
            {
              hid: "ga",
              innerHTML: `
             (function (i, s, o, g, r, a, m) {
            i["GoogleAnalyticsObject"] = r;
            (i[r] =
              i[r] ||
              function () {
                (i[r].q = i[r].q || []).push(arguments);
              }),
              (i[r].l = 1 * new Date());
            (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
          })(
            window,
            document,
            "script",
            "https://www.google-analytics.com/analytics.js",
            "ga"
          );
          ga("create", "UA-46172202-22", "auto", { allowLinker: true });
          ga("set", "anonymizeIp", true);
          ga("require", "GTM-K9BGS8K");
          ga("require", "displayfeatures");
          ga("require", "linker");
          ga("linker:autoLink", ["2checkout.com", "avangate.com"]);
              `,
              type: "text/javascript",
              charset: "utf-8",
            },

            {
              hid: "gtm-script2",
              innerHTML: `
             (function(w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
              var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != "dataLayer" ? "&l=" + l : "";
              j.async = true;
              j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
              f.parentNode.insertBefore(j, f);
            })(window, document, "script", "dataLayer", "GTM-NKDMSK6");
              `,
              type: "text/javascript",
              charset: "utf-8",
            },
          ];
        }
      })(),
    };
  },
  mounted(){
    window.Echo.channel(`Notificaciones`).listen('NotificacionOperacionesEvent',(data)=>{  
      if(data.type === 'warning'){
        this.$notify({
            type: "warning",
            title: data.title,
            message: data.body,
            duration: -1
        });
      }
      if(data.type === 'danger'){
        this.$notify({
            type: "danger",
            title: data.title,
            message: data.body,
            duration: -1
        });
        this.logout();
      }
    })
  },
  beforeDestroy() {
    if (window.Echo) {
      window.Echo.leave('Notificaciones');
    }
  },
  methods: {
    async logout() {
      try {
        localStorage.removeItem('vue-authenticate.vueauth_access_token');
        if (window.Echo) {
          window.Echo.leave('Notificaciones');
        }
        
        await this.$store.dispatch("logout");
        
        if (this.$route.name !== 'Login') {
          this.$router.push({ name: "Login" }).catch(() => {});
        }
      } catch (error) {
        console.error("Error en logout:", error);
        this.$router.push({ name: "Login" });
      }
    },
  }
};
</script>
<style>
  .hover-apolo:hover{
    background-color: #6074dd !important;
    color: #fff !important;
  }
  .apolo-borde{
    border-radius: 45px 0px 0px 45px !important;
  }
  .apolo-borde-complemento{
    border-radius: 0px 45px 45px 0px !important;
  }
  .table td, .el-table td  {
    color: #333333 !important;
    font-weight: 600 !important;
  }
  .el-input__inner {
    border: 1px solid #0068a1 !important;
      color: #0068a1 !important;
      font-weight: 600 !important;
  }
  .el-select .el-input .el-select__caret {
    color: #0068a1 !important;
    font-weight: 600 !important;
  }
  .form-control{
    color: #333 !important;
    font-weight: 600 !important;
  }
  .input-group-text {
    color: #0068a1 !important;
    font-weight: 600 !important;
  }
  .form-control-label {
      font-size: 1.1rem !important;
      color: #333333 !important;
  }
  .navbar-vertical .navbar-nav .nav-link {
      font-weight: 600 !important;
      color: #333 !important;
  }
  .navbar-light .navbar-nav .show > .nav-link, .navbar-light .navbar-nav .active > .nav-link, .navbar-light .navbar-nav .nav-link.show, .navbar-light .navbar-nav .nav-link.active {
    color: #0068a1 !important;
  }
  .navbar-vertical .navbar-nav .nav-link[data-toggle=collapse]:after { 
    color: #333 !important;
  }
  body {
      color: #333 !important;
      font-weight: 600 !important;
  }
  h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    font-weight: 700 !important;
    color: #333 !important;
  }
  h3, .h3 {
      font-size: 1.2625rem !important;
  }
  .modal-primary .modal-content {
    color: #333 !important;
  }
</style>
